<template>
  <div class="app">
    <Base v-if="show" />
    <Modal v-if="modal.show" class="fadeIn animated" />
    <!-- <OutsideScript src="//zt.ztgame.com/js/v19/jquery-1.7.2.min.js" /> -->
    <OutsideScript src="//zthj.ztgame.com/js/download_link.js" />
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus">
.app {
  width: 100%;
  // height: 100%;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  /* background-color:#fff; */
  display: none;
}

::-webkit-scrollbar:hover {
  background-color: #eee;
}

::-webkit-scrollbar-thumb {
  min-height: 5px;
  min-width: 5px;
  -webkit-border-radius: 20px;
  border: 1px solid #AAA;
  background-color: #AAA;
}

::-webkit-scrollbar-thumb:hover {
  min-height: 5px;
  min-width: 5px;
  -webkit-border-radius: 20px;
  border: 1px solid #444;
  background-color: #444;
}

::-webkit-scrollbar-thumb:active {
  -webkit-border-radius: 20px;
  border: 1px solid #444;
  background-color: #444;
}
</style>
<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import Base from './views/base/base.vue';
import Modal from './components/Modal/modal.vue';
import OutsideScript from './components/OutsideScript/outsidescript.vue';
// import Orientation from './components/Orientation/orientation.vue';
import store from './store/index';
import * as types from './store/mutation-type';
import '@babel/polyfill';
// import gRequire from 'ztgamejs/grequire';

Vue.prototype.$alert = alert;
Vue.prototype.$confirm = confirm;

export default {
  components: {
    Modal,
    Base,
    OutsideScript
    // Orientation
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapState({
      modal: state => state.modal,
      showGuide: state => state.showGuide,
      alert: state => state.alert
    })
  },
  async mounted() {
    this.show = true;
  },
  methods: {
    closeAlert() {
      store.commit(types.HIDE_ALERT);
    },
    close() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>
